import styled from 'styled-components'
import pattern from '../../assets/imagens/pattern.png'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

export const Container = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-image: url( ${pattern} );
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  background-color: white;
  border-radius: 10px;
  padding: 16px;
  text-align: center;
  width: 500px;
  height: 300px;
`

export const Title = styled.div`
  color: ${StyleGuide.cores.cinza500};
  font-size: 20px;
  font-family: Work Sans;
  font-weight: bold;
`

export const Image = styled.img`
  max-height: 158px;
  max-width: 120px;
  overflow: auto;
`

export const Content = styled.div`
  color: ${StyleGuide.cores.cinza500};
  font-family: Work Sans;
`
